
import { computed, defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Bid, MaterialListItem } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';

export default defineComponent({
  name: 'MaterialListItemDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    materialListItem: {
      type: Object as PropType<MaterialListItem>,
      required: true
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const store = useStore();
    const localBidMaterialList = computed(() => store.state.bids.data.localBid.materialList);
    const submit = async () => {
      if (props.materialListItem) {
        const indexToDelete = localBidMaterialList.value.findIndex(
          item =>
            item.materialDisplayName === props.materialListItem.materialDisplayName &&
            item.truckDisplayName === props.materialListItem.truckDisplayName &&
            item.vendorDisplayName === props.materialListItem.vendorDisplayName
        );

        if (indexToDelete !== -1) {
          const updatedMaterialList = [
            ...localBidMaterialList.value.slice(0, indexToDelete),
            ...localBidMaterialList.value.slice(indexToDelete + 1)
          ];

          await store.dispatch.bids.updateLocalBid({
            materialList: updatedMaterialList
          } as Bid);
        }
      }
      isOpen.value = false;
    };
    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
